import React from "react";
import ReactJoyride, { STATUS, Step } from "react-joyride";
import { styles, locale } from "./JoyRideSteps";
interface JoyrideProps {
    steps: Step[];
    isJoyRideRunning: boolean;
    onFinish: () => void;
}

const JoyRideComponent: React.FC<JoyrideProps> = ({
    steps,
    isJoyRideRunning,
    onFinish,
}) => {
    return (
        <ReactJoyride
            steps={steps}
            run={isJoyRideRunning}
            spotlightPadding={0}
            disableScrolling={true}
            continuous
            showSkipButton
            showProgress
            disableOverlayClose
            spotlightClicks
            callback={(data) => {
                const { action } = data;
                if (
                    data.status === STATUS.FINISHED ||
                    data.status === STATUS.SKIPPED ||
                    data.status === STATUS.PAUSED ||
                    action === "close"
                ) {
                    onFinish();
                }
            }}
            styles={styles}
            locale={locale}
        />
    );
};

export default JoyRideComponent;